import * as React from 'react';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { FormGroup, HelpBlock, ControlLabel } from '../bootstrap-components/BootstrapComponents';
export function formGroup(label: string, formControl: any, validationError?: ValidationError) {
    var validationState: 'error' | undefined = undefined;
    var errorMessage = null;
    if (validationError) {
        validationState = 'error';
        errorMessage = validationError.error;
    }
    return (
        <FormGroup validationState={validationState}>
            {label.length > 0 &&
                <ControlLabel>{label}</ControlLabel>
            }
            {formControl}
            <HelpBlock>{errorMessage}</HelpBlock>
        </FormGroup>
    );
}

export function getErrorMessage(errorMessages?: ValidationError[], field?: string): ValidationError | undefined {
    if (errorMessages === undefined || field === undefined) {
        return undefined;
    }

    if (errorMessages) {
        return errorMessages.find(e => e.field.toLowerCase() === field.toLocaleLowerCase());
    }
    return undefined;
}

export function onControlChangedChange(e: any, callBack: (name: string, value: string) => void) {
    if (e.target.type === 'checkbox') {
        callBack(e.target.name, e.target.checked);
    } else {
        callBack(e.target.name, e.target.value);
    }
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/input/FormFunctions.tsx